import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Event = {
  id: string;
  name: string;
  status: 'active' | 'completed' | 'cancelled';
  draw_date: string | null;
  created_at: string;
};

export type Entry = {
  id: string;
  campaign_id: string;
  email: string;
  name: string | null;
  phone_number?: string;
  ticket_number: string;
  payment_status: 'pending' | 'paid' | 'failed';
  payment_method: 'online' | 'inPerson';
  total_amount?: number;
  quantity?: number;
  created_at: string;
  is_winner?: boolean;
  prize_id?: string;
  campaign?: Campaign;
  prize?: Prize;
};

export type Organization = {
  id: string;
  name: string;
  owner_id: string;
  organization_type: string;
  organization_age: number;
  tax_id: string;
  state_registration: string;
  created_at: string;
};

export type Campaign = {
  id: string;
  org_id: string;
  name: string;
  description: string | null;
  start_date: string;
  end_date: string;
  ticket_price: number;
  max_tickets: number | null;
  status: 'draft' | 'active' | 'paused' | 'completed' | 'cancelled';
  created_at: string;
};

export type Prize = {
  id: string;
  campaign_id: string;
  name: string;
  description: string | null;
  value: number;
  rank: number;
  created_at: string;
};

export type Proceeds = {
  id: string;
  campaign_id: string;
  recipient: string;
  percentage: number;
  created_at: string;
};